import { FC } from 'react';
import { IOptimizedSpectraData } from '@pro/linearTopLight/interface';
import cn from 'classnames';
import styles from './index.module.less';
import { ModuleHeader } from '@app/linearTopLight/ModuleHeader';
import { GridRender } from '@base/snippets/GridRender';
import Image from '@base/lib/ThemeImage';
import { HtmlRender } from '@base/snippets/HtmlRender';

type IOptimizedSpectraProps = {
    data: IOptimizedSpectraData;
};

export const OptimizedSpectra: FC<IOptimizedSpectraProps> = ({ data }) => {
    const { pictures, spectraTuned } = data;

    return (
        <div className={cn(styles.spectra, 'g-wrapper')}>
            <ModuleHeader title={data.title} description={data.description}/>

            <GridRender
                className={styles.pictures}
                colsPerRow={2}
                gutter={68}
                list={pictures.list}
                render={item => (
                    <Image
                        width={pictures.width}
                        height={pictures.height}
                        src={item}
                        background={false}
                    />
                )}
            />

            <div className={styles.tuned}>
                <HtmlRender className={cn(styles['tuned-title'], 'text-center')} html={spectraTuned.title}/>
                <GridRender
                    colsPerRow={3}
                    gutter={97}
                    list={spectraTuned.list}
                    render={item => (
                        <div className={cn(styles['tuned-item'], 'flex flex-middle')}>
                            <Image
                                src={item.icon}
                                width={32}
                                fixed
                                background={false}
                                pure
                            />
                            <HtmlRender className={styles['tuned-item-title']} html={item.title}/>
                        </div>
                    )}
                />

            </div>
        </div>
    )
};
